import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api/api";

export const Profile = () => {
  const navigate = useNavigate();
  const [locOn, setLocOn] = useState(false);       // could be tied to real setting later
  const [notifOn, setNotifOn] = useState(true);    // example toggle

  const Row = ({ icon, title, sub, onClick, withChevron = true }) => (
    <button onClick={onClick} className="w-full text-left">
      <div className="px-4 py-3 flex items-center justify-between border-b border-[#eadfb7]">
        <div className="flex items-center gap-3">
          {icon}
          <div>
            <p className="font-semibold">{title}</p>
            {sub && <p className="text-[12px] text-[#5d4037]/80">{sub}</p>}
          </div>
        </div>
        {withChevron && (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            fill="none"
            stroke="#5d4037"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            <path d="M9 18l6-6-6-6" />
          </svg>
        )}
      </div>
    </button>
  );

  const ToggleRow = ({ icon, title, on, setOn }) => (
    <div className="px-4 py-3 flex items-center justify-between border-b border-[#eadfb7]">
      <div className="flex items-center gap-3">
        {icon}
        <p className="font-semibold">{title}</p>
      </div>
      <button
        onClick={() => setOn(!on)}
        className={`relative w-11 h-6 rounded-full transition-colors ${
          on ? "bg-[#5d4037]" : "bg-[#e8dcb7]"
        }`}
      >
        <span
          className={`absolute top-1 left-1 w-4 h-4 rounded-full bg-white transition-transform ${
            on ? "translate-x-5" : ""
          }`}
        />
      </button>
    </div>
  );

  return (
    <div className="min-h-screen grid place-items-center bg-[#fff8e1]">
      <div className="relative app-container [font-family:'Nunito',Helvetica] text-[#5d4037] pb-40">

        {/* Header */}
        <div className="w-full flex items-center mt-4">
          <button
            onClick={() => navigate(-1)}
            className="ml-4 w-9 h-9 rounded-full bg-[#ccb357] grid place-items-center"
            aria-label="Back"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="none"
              stroke="#5d4037"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path d="M15 18l-6-6 6-6" />
            </svg>
          </button>
          <h1 className="flex-1 text-center font-bold text-[18px]">My Profile</h1>
          <div className="w-9" />
        </div>

        {/* Avatar */}
        <div className="w-full flex justify-center mt-4">
          <div className="relative">
            <img
              alt="Profile"
              className="w-[96px] h-[96px] rounded-full object-cover border-4 border-[#ccb357]"
              src="https://cdn-icons-png.flaticon.com/512/149/149071.png"
            />
            <button className="absolute right-0 bottom-0 w-7 h-7 rounded-full bg-[#5d4037] grid place-items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="#f7c945"
              >
                <path d="M18 2l4 4-10 10H8v-4L18 2z" />
              </svg>
            </button>
          </div>
        </div>

        {/* Sections */}
        <div className="mt-6">
          <p className="px-4 text-[12px] font-extrabold uppercase">Profile</p>

          <Row
            title="Edit Profile"
            onClick={() => navigate("/update-profile")}
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="#5d4037"
              >
                <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25z" />
                <path d="M20.71 7.04a1.003 1.003 0 000-1.42l-2.34-2.34a1.003 1.003 0 00-1.42 0l-1.83 1.83 3.75 3.75 1.84-1.82z" />
              </svg>
            }
          />

          <Row
            title="Update Location"
            sub="Benin City, Edo (tap to change)"
            onClick={() => navigate("/update-location")} // ← link to your UpdateLocation page
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="#5d4037"
              >
                <path d="M12 2C8 2 5 5 5 9c0 5 7 13 7 13s7-8 7-13c0-4-3-7-7-7zm0 9.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z" />
              </svg>
            }
          />

          <Row
            title="My Store / Create Store"
            sub="Manage store details, hours, menu"
            onClick={() => navigate("/store-info")}
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="#5d4037"
              >
                <path d="M3 3h18v2H3zM4 7h16v14H4z" />
                <path d="M9 11h6v2H9z" />
              </svg>
            }
          />

          <p className="px-4 mt-4 text-[12px] font-extrabold uppercase">Store & Settings</p>

          <Row
            title="Products / Menu"
            onClick={() => navigate("/products")}
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="#5d4037"
              >
                <path d="M4 7h16v2H4zM4 11h16v2H4zM4 15h16v2H4z" />
              </svg>
            }
          />

          {/* <Row
            title="Bank & Payouts"
            sub="Update account details"
            onClick={() => navigate("/payout-settings")} // ← placeholder route
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="#5d4037"
              >
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
                <path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4z" />
              </svg>
            }
          /> */}

          <ToggleRow
            title="Store Notifications"
            on={notifOn}
            setOn={setNotifOn}
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="#5d4037"
              >
                <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z" />
              </svg>
            }
          />

          <p className="px-4 mt-4 text-[12px] font-extrabold uppercase">Security</p>

          <Row
            title="Change password"
            onClick={() => navigate("/forgot-password")}
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="#5d4037"
              >
                <path d="M7 11V7a5 5 0 0110 0v4" />
                <rect x="5" y="11" width="14" height="10" rx="2" />
              </svg>
            }
          />

          {/* Logout */}
          <button
            onClick={async () => {
              try {
                await api.auth.logout();
              } catch (err) {
                console.warn("Logout failed:", err);
              } finally {
                localStorage.removeItem("sp_token");
                localStorage.removeItem("sp_user");
                localStorage.removeItem("sp_role");
                localStorage.removeItem("sp_userId");
                window.location.href = "/auth/login";
              }
            }}
            className="w-full"
          >
            <div className="px-4 py-3 flex items-center gap-3 text-[#c34040]">
              <span>!</span>
              <span>Log Out</span>
            </div>
          </button>
        </div>

        {/* Bottom navigation remains unchanged */}
        <div className="fixed bottom-3 md:bottom-6 left-1/2 -translate-x-1/2 w-full max-w-[1440px] xl:max-w-[1600px] px-6 md:px-10 xl:px-16">
          <div className="px-6 pt-2 pb-4 bg-white border-t border-[#eadfb7]">
            <div className="grid grid-cols-4 gap-4 text-[12px] text-[#5d4037]">
              <div className="flex flex-col items-center" onClick={() => navigate("/dashboard")}>
                <div className="w-9 h-9 rounded-[12px] bg-white border border-[#eadfb7] grid place-items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    fill="none"
                    stroke="#5d4037"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                  >
                    <path d="M3 10.5L12 4l9 6.5" />
                    <path d="M5 10v10h14V10" />
                  </svg>
                </div>
                <span className="mt-1 text-[#5d4037]/80">Overview</span>
              </div>

              <div className="flex flex-col items-center" onClick={() => navigate("/orders")}>
                <div className="w-9 h-9 rounded-[12px] bg-white border border-[#eadfb7] grid place-items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    fill="none"
                    stroke="#5d4037"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                  >
                    <rect x="4" y="3" width="16" height="18" rx="2" />
                    <path d="M8 7h8M8 11h6M8 15h8" />
                  </svg>
                </div>
                <span className="mt-1 text-[#5d4037]/80">Orders</span>
              </div>

              <div className="flex flex-col items-center" onClick={() => navigate("/products")}>
                <div className="w-9 h-9 rounded-[12px] bg-white border border-[#eadfb7] grid place-items-center">
                  <div className="w-6 h-6 rounded-full border border-[#5d4037] grid place-items-center">
                    <span className="text-[11px] font-bold leading-none text-[#5d4037]">P</span>
                  </div>
                </div>
                <span className="mt-1 text-[#5d4037]/80">Products</span>
              </div>

              <div className="flex flex-col items-center">
                <div className="w-9 h-9 rounded-[12px] bg-white border border-[#eadfb7] grid place-items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#5d4037"
                    strokeWidth="2"
                  >
                    <path d="M12 12a4 4 0 100-8 4 4 0 000 8z" />
                    <path d="M20 21v-2a6 6 0 00-6-6H10a6 6 0 00-6 6v2" />
                  </svg>
                </div>
                <span className="mt-1 font-semibold">Profile</span>
              </div>
            </div>
          </div>
          <div className="h-[22px] bg-[#5d4037] flex items-center justify-center">
            <div className="w-[120px] h-[6px] rounded-full bg-white" />
          </div>
        </div>
      </div>
    </div>
  );
};